import axios from "axios";
import store from "@/general/store";
import {
  Module,
  VuexModule,
  Mutation,
  getModule,
  Action,
  MutationAction
} from "vuex-module-decorators";
import { getGrantCriteriaDetails } from "../api";
import { GrantCriteria, GrantCriteriaDetail } from "gen/ricapi/api";

@Module({
  name: "grantcriteriadetails",
  namespaced: true,
  store: store,
  dynamic: true
})
class GrantCriteriaDetailsModule extends VuexModule {
  grantCriteriaDetailsModel: GrantCriteriaDetail | null = null;

  @MutationAction
  async getGrantCriteriaDetails() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const idParam = urlParams.get("id");
    const id = idParam ? parseInt(idParam) : 1;
    const orderingParam = urlParams.get("ordering");

    const searchParam = urlParams.get("search");
    const ordering = orderingParam ? orderingParam : "";

    const search = searchParam ? searchParam : "";

    const grantCriteriaDetailsModel = await getGrantCriteriaDetails(
      id,
      ordering,
      search
    );
    return { grantCriteriaDetailsModel };
  }
}

export default getModule(GrantCriteriaDetailsModule);
